import api from "../../Hooks/axiosApi";

export const createAreaService = (data: any) => {
    return api.post('/api/crm/InsertCrmAreas', data);
};

export const updateAreaService = (data: any) => {
    return api.put(`/api/crm/UpdateCrmAreas/${data.areaId}`, data);
};

export const deleteAreaService = (id: any) => {
    return api.delete(`/api/crm/DeleteCrmAreas/${id}`);
};

export const getAllAreasService = () => {
    return api.get('/api/crm/GetAllCrmareas');
};

export const getAreaByIdService = (id: any) => {
    return api.get(`/api/crm/GetCrmareasbyid/${id}`);
};   